import { ChakraProvider } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ActionCable from "actioncable";
import * as React from "react";
import "./App.css";
import { SERVICES } from "./config";
import AppRoutes from "./routes/routes";
import theme from "./theme";
import Fonts from "./theme/styles/fonts";
import { AuthProvider } from "./utils/context/AuthContext";
import VersionChecker from "./components/VersionChecker";

const AppContainer = styled.div`
  font-family: "Red Hat Display Variable";
`;

const CableApp: { cable: ActionCable.Cable | null } = { cable: null };
CableApp.cable = ActionCable.createConsumer(SERVICES.socketUrl);
export const ActionCableContext = React.createContext(CableApp);

export const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error: any) => {
          if (error?.response?.status === 401) {
            return false;
          }
          return failureCount < 3;
        },
        onError: (error: any) => {
          if (error?.response?.status === 401) {
            localStorage.clear();
            window.location.reload();
          }
        },
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ActionCableContext.Provider value={CableApp}>
        <AuthProvider>
          <ChakraProvider theme={theme}>
            <Fonts />
            <VersionChecker />
            <AppContainer>
              {/* <IdleTracking> */}
              <AppRoutes />
              {/* </IdleTracking> */}
            </AppContainer>
          </ChakraProvider>
        </AuthProvider>
      </ActionCableContext.Provider>
    </QueryClientProvider>
  );
};
